import gql from 'graphql-tag';

/**
 * Query to fetch inspection instances with pagination and filtering.
 * Uses offset-based pagination for list views.
 * 
 * Note: This query excludes responses, observations, and events fields
 * to optimize payload size for list views. Use inspectionInstance query
 * for full instance details.
 */
export const getInspectionInstancesQuery = gql`
  query getInspectionInstances(
    $channelId: UUID!
    $search: InspectionInstanceSearchInput
    $pagination: PaginationInput!
  ) {
    inspectionInstances(
      channelId: $channelId
      search: $search
      pagination: $pagination
    ) {
      inspectionInstances {
        id
        schemaVersion
        version
        customName
        templateRef {
          templateId
          version
          templateName
        }
        metadata {
          buildingId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          tenantId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          suiteId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          assignedTo
          scheduledFor
          scheduleId
          createdAt
          createdBy
          createdByUser {
            _id
            name
          }
        }
        state {
          status
          startedAt
          completedAt
          completedBy
          completedByUser {
            _id
            name
          }
          closedReason
          progress {
            totalItems
            completedItems
            requiredItems
            completedRequiredItems
            sectionProgress {
              sectionId
              total
              completed
            }
          }
        }
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
